import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import { useStateContext } from "../../../context/AppContext";
import img1 from "../../../assets/Images/hero/hero-img1.webp";
import img2 from "../../../assets/Images/hero/hero-img2.webp";
import img3 from "../../../assets/Images/hero/hero-img3.webp";
import img4 from "../../../assets/Images/hero/hero-img4.webp";
import img5 from "../../../assets/Images/hero/hero-img5.webp";
import "./Hero.css";

export default function Hero() {
  const navigate = useNavigate();
  const { dark } = useStateContext();

  const slides = useMemo(
    () => [
      {
        id: 1,
        image: img1,
        title: "Build AI Powered Web, Mobile, Desktop & SaaS Applications",
        text: "Create intelligent, scalable solutions with AI-driven innovation.",
        link: "/ai-chatbot-and-saas-solutions",
      },
      {
        id: 2,
        image: img2,
        title: "AI Voice Assistant & AI Agent",
        text: "Seamless AI-powered interactions for smarter communication.",
        link: "/services/ai-voice-assistant-ai-agent",
      },
      {
        id: 3,
        image: img3,
        title: "Web Development",
        text: "Crafting Scalable, High-Performance Websites & Web Apps",
        link: "/services/web-development",
      },
      {
        id: 4,
        image: img4,
        title: "Mobile App Development (Android and iOS- Hybrid Apps)",
        text: "Seamless & Scalable Hybrid App Solutions for Android & iOS",
        link: "/services/mobile-app-development-android-ios-hybrid-apps",
      },
      {
        id: 5,
        image: img5,
        title: "Machine Learning and deep learning Solutions",
        text: "Cutting-Edge AI Solutions with Machine Learning & Deep Learning",
        link: "/services/machine-learning-deep-learning-solutions",
      },
    ],
    []
  );

  useEffect(() => {
    slides.forEach((slide) => {
      const img = new Image();
      img.src = slide.image;
    });
  }, [slides]);

  return (
    <div className="hero-section">
      <Carousel interval={4000} pause={false}>
        {slides.map((slide) => (
          <Carousel.Item key={slide.id}>
            <div
              className="hero-carousel"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="overlay"></div>
              <div className="hero-content">
                <h1>{slide.title}</h1>
                <p>{slide.text}</p>
                <button
                  className="hero-button"
                  style={{ backgroundColor: dark }}
                  onClick={() => navigate(slide.link)}
                >
                  Get Started
                </button>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
